<template>
  <q-btn v-bind="$attrs" :disable="disable || isReadOnly">
    <q-tooltip v-if="tooltipText" class="read-only-btn-tooltip">{{ tooltipText }}</q-tooltip>
    <slot />
  </q-btn>
</template>

<script setup>
import { computed } from 'vue'

import { isReadOnly } from 'src/composables/app/useAuth'

import { NOTIFICATION_MESSAGES } from 'src/services/consts/notification.const'

defineOptions({ inheritAttrs: false })

const props = defineProps({
  disable: { type: Boolean, default: false },
  tooltip: { type: String, default: undefined },
})

const tooltipText = computed(() =>
  isReadOnly.value ? NOTIFICATION_MESSAGES.error.permissionDenied : props.tooltip,
)
</script>

<style lang="scss">
.read-only-btn-tooltip {
  white-space: pre-line;
}
</style>
